import Config from '../../Config'

class Helper{
    isBottomPage() {

        const windowHeight = "innerHeight" in window ? window.innerHeight : document.documentElement.offsetHeight;
        const body = document.body;
        const html = document.documentElement;
        const docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
        const windowBottom = windowHeight + window.pageYOffset;
        return windowBottom >= docHeight
    }
    isDevEnvironment(){
        return Config.AMBIENTE !== 'RELEASE'
    }
}

const help = new Helper()

export default help


// WEBPACK FOOTER //
// ./src/components/Sistema/Helper.js